import React from 'react';
import { Collapse } from '@mui/material';

/**
 * @param {Object} props
 * @param {boolean} props.if
 */
export default function Conditional({ children, if: condition = false }) {
    return (
        <Collapse in={condition} timeout={200} mountOnEnter unmountOnExit>
            <div>
                {children}
            </div>
        </Collapse>
    );
}